import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllJobDescription = async ({ offset = 0, limit = 10, filters = {}, recruitmentpartnerId = "", testinvite = false } = {}) => {
  try {
    const url = `${jsonConfig.apiUrl}getjd?offset=${offset}&limit=${limit}`;
    const response = await axios.post(
      url,
      { filters, recruitmentpartnerId, testinvite },
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    // backend returns: { data: finalResponse }
    return response.data?.data || {};
  } catch (error) {
    // bubble up error
    throw error;
  }
};

export default getAllJobDescription;